import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { ApiTravelMediaImportHelperService } from './travel-media-import-helper.service';

@Injectable({ providedIn: 'root' })
export class ApiTravelMediaImportService {
  constructor(
    public hpr: ApiTravelMediaImportHelperService,
    private _api: ApiService,
  ) {}

  get(id: number | string) {
    return this._api.get('travel-media-import/get/id/' + id);
  }

  list(data: any = {}) {
    return this._api.post('travel-media-import/list', data);
  }

  create(data: any) {
    return this._api.post('travel-media-import/create', data);
  }

  update(data: any) {
    return this._api.post('travel-media-import/update', data);
  }

  assign(data: any) {
    return this._api.post('travel-media-import/assign', data);
  }

  remove(id: number) {
    return this._api.post('travel-media-import/remove/id/' + id);
  }
}
